<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5409 14.5624C10.6554 14.5622 10.7659 14.6058 10.8505 14.6847C10.9351 14.7637 10.9878 14.8722 10.9981 14.9888C11.0085 15.1055 10.9757 15.2219 10.9064 15.3151C10.837 15.4083 10.7361 15.4716 10.6234 15.4925L10.5409 15.5H0.459107C0.344591 15.5002 0.234146 15.4566 0.14952 15.3776C0.0648947 15.2987 0.0122225 15.1902 0.00187543 15.0735C-0.00847166 14.9569 0.0242563 14.8405 0.0936149 14.7473C0.162973 14.654 0.263936 14.5908 0.37662 14.5699L0.459107 14.5624H10.5409ZM5.5 0.5C5.60726 0.499963 5.71113 0.538416 5.79353 0.60866C5.87592 0.678904 5.93162 0.77649 5.95093 0.884423L5.95826 0.968809L5.9546 12.0271L9.29533 8.60664C9.37104 8.52883 9.47105 8.48068 9.5779 8.47057C9.68476 8.46046 9.7917 8.48904 9.88008 8.55132L9.94423 8.6057C10.0201 8.68327 10.067 8.78563 10.0768 8.89495C10.0865 9.00426 10.0584 9.1136 9.99739 9.2039L9.94423 9.26953L5.8272 13.4888C5.76336 13.5541 5.68202 13.5984 5.59349 13.6163L5.49633 13.6257C5.42634 13.6256 5.3573 13.6091 5.29453 13.5774C5.23177 13.5457 5.17695 13.4997 5.13431 13.4429L1.04935 9.26953C0.967845 9.187 0.91955 9.07621 0.914001 8.95903C0.908452 8.84184 0.946052 8.72679 1.01938 8.63659C1.0927 8.54638 1.19643 8.48758 1.31006 8.4718C1.4237 8.45601 1.53899 8.48438 1.63318 8.55132L1.69733 8.6057L5.03807 12.0196L5.04174 0.968809C5.04174 0.844473 5.09002 0.725229 5.17596 0.637311C5.2619 0.549392 5.37846 0.5 5.5 0.5Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    viewBox: { type: String, default: "0 0 11 16" },
    width: { type: [Number, String], default: 11 },
    height: { type: [Number, String], default: 16 },
    iconName: { type: String, default: "icon" },
    fill: { type: String, default: "#0038FF" },
  },
};
</script>
